import { create } from 'zustand';
import { Seat, SeatStatusResponse, SeatFilter } from '../types';

interface SeatState {
  // 좌석 데이터
  seats: Seat[];
  seatStatus: SeatStatusResponse | null;
  selectedSeat: Seat | null;

  // 필터
  filters: SeatFilter;

  // 로딩 상태
  isLoading: boolean;
  lastUpdated: Date | null;

  // 액션
  setSeats: (seats: Seat[]) => void;
  setSeatStatus: (status: SeatStatusResponse) => void;
  setSelectedSeat: (seat: Seat | null) => void;
  setFilters: (filters: SeatFilter) => void;
  setLoading: (loading: boolean) => void;
  updateSeatStatus: (seatNumber: number, status: Partial<Seat>) => void;

  // 유틸리티
  getAvailableSeats: () => Seat[];
  getSeatBySeatNumber: (seatNumber: number) => Seat | undefined;
  clearFilters: () => void;
}

export const useSeatStore = create<SeatState>((set, get) => ({
  // 초기 상태
  seats: [],
  seatStatus: null,
  selectedSeat: null,
  filters: {
    exclude_out_of_order: true,
  },
  isLoading: false,
  lastUpdated: null,

  // 액션
  setSeats: (seats) => set({ seats, lastUpdated: new Date() }),

  setSeatStatus: (status) => set({ seatStatus: status }),

  setSelectedSeat: (seat) => set({ selectedSeat: seat }),

  setFilters: (filters) => set({ filters }),

  setLoading: (loading) => set({ isLoading: loading }),

  updateSeatStatus: (seatNumber, status) => {
    const { seats } = get();
    const updatedSeats = seats.map((seat) =>
      seat.seat_number === seatNumber ? { ...seat, ...status } : seat
    );
    set({ seats: updatedSeats, lastUpdated: new Date() });
  },

  // 유틸리티 함수
  getAvailableSeats: () => {
    const { seats } = get();
    return seats.filter((seat) => seat.is_available && !seat.is_out_of_order);
  },

  getSeatBySeatNumber: (seatNumber) => {
    const { seats } = get();
    return seats.find((seat) => seat.seat_number === seatNumber);
  },

  clearFilters: () =>
    set({
      filters: { exclude_out_of_order: true },
    }),
}));
